import { render, staticRenderFns } from "./GetCodeWidget.vue?vue&type=template&id=1d87cbc4&scoped=true&"
import script from "./GetCodeWidget.vue?vue&type=script&lang=js&"
export * from "./GetCodeWidget.vue?vue&type=script&lang=js&"
import style0 from "./GetCodeWidget.vue?vue&type=style&index=0&id=1d87cbc4&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d87cbc4",
  null
  
)

export default component.exports